<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <el-form :inline="true" size="mini">
          <span class="form-date-picker">
            <el-form-item label="日期:">
              <el-date-picker style="width: 150px" v-model="form.startDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker style="width: 150px" v-model="form.endDateStr" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </span>
          <el-form-item style="float: right; margin-top: -1px">
            <button class="ioc-button i-mini i-success" @click="handleSearch">搜索</button>
          </el-form-item>
        </el-form>
      </template>
      <template slot="main-header">
        <el-button type="primary" size="mini" @click="showExport">批量导入 </el-button>
      </template>
    </import-task>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="70px">
          <el-row class="itembox">
            <el-col :span="24" align="left">
              <el-form-item label="店铺">
                {{ storeName }}
              </el-form-item>
            </el-col>
            <el-col :span="24" align="left">
              <el-form-item label="导入说明">
                由此处导入{{ nextCurrentMonth }}月“{{ currentMonthStr(nextCurrentMonth) }}月预估”及{{ +currentMonth }}月的“{{ currentMonthStr(+currentMonth) }}月预估调整”
              </el-form-item>
            </el-col>
            <el-col :span="24" align="left">
              <el-form-item label="导入类型" prop="importType">
                <el-radio-group v-model="requestParam.importType">
                  <el-radio :label="1">
                    覆盖导入
                    <el-tooltip class="item" effect="dark" placement="top">
                      <span class="el-icon-question"></span>
                      <div slot="content">即删除原有导入数据，重新导入最新数据；</div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2">
                    新增导入
                    <el-tooltip class="item" effect="dark" placement="top">
                      <span class="el-icon-question"></span>
                      <div slot="content">即在之前的基础上传额外新增数据，如有相同商品，则覆盖之前商品数据；</div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid(0)"
                    >仅上传
                  </el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid(1)"
                    >上传并提报
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                  <!-- <div slot="tip">
                    注:由此处导入{{ nextCurrentMonth }}月“{{ currentMonthStr(nextCurrentMonth) }}月预估”及{{ +currentMonth }}月的“{{ currentMonthStr(+currentMonth) }}月预估调整”
                  </div> -->
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer"><el-button @click="cancel" size="medium">取 消</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
export default {
  data() {
    return {
      form: {
        startDate: '',
        endDate: '',
        endDateStr: '',
        reportName: '',
        appCode: 'ec-pc-new',
      },
      dialogFormVisible: false,
      titleName: '',
      requestParam: {},
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      rules: {},
      fjLoading: false,
      storeName: '',
    };
  },
  computed: {
    // 当前所在月份
    currentMonth() {
      let planTime = this.$route.query.planTime;
      return planTime.split('-')[1]
    },
    // 当前所在月份的下一个月
    nextCurrentMonth() {
      return +this.currentMonth + 1 == 13 ? 1 : +this.currentMonth + 1
    },
  },
  methods: {
    handleSearch() {
      this.form.endDate = this.form.endDateStr == null || this.form.endDateStr == '' ? this.form.endDateStr : this.form.endDateStr.substr(0, 10) + ' 23:59:59';
      this.$refs['importTask'].init(this.form);
    },
    showExport() {
      this.fileList = [];
      this.dialogFormVisible = true;
      let filename = this.$route.query.fileName;
      filename = filename.substring(0, filename.lastIndexOf('.'));
      this.titleName = filename + '批量维护';
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(type) {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          if (!this.requestParam.importType) {
            this.$message.error('请选择导入类型');
            return;
          }
          if (!this.fileList || this.fileList.length === 0) {
            this.$message.error('请先上传Excel附件');
            return;
          }
          if (type == 0) {
            this.submitUpload(type);
            return
          }
          this.$confirm('如文件上传导入成功，系统将自动提报，如上传导入失败，则不会进行提报。', '提示', {
            confirmButtonText: '确认上传',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            customClass: 'my-dialog',
          }).then(() => {
            this.submitUpload(type);
          });
          
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    submitUpload(type) {
      this.fjLoading = true;
      let taskDTO = null;
      let query = this.$route.query;
      let fields = [
        {
          columnName: '店铺',
          columnValue: this.storeName,
          fieldName: 'storeId',
          fieldValue: query.storeId,
          relation: 'storeId',
        },
        {
          columnName: '提报日期',
          columnValue: query.planTime,
          fieldName: 'planTime',
          fieldValue: query.planTime,
          relation: 'planTime',
        },
        //导入类型
        {
          columnName: '',
          columnValue: '',
          fieldName: 'importType',
          fieldValue: this.requestParam.importType,
          relation: 'importType',
        },
        //导入并提报
        {
          columnName: '',
          columnValue: '',
          fieldName: 'importAndCommit',
          fieldValue: type,
          relation: 'importAndCommit',
        },
      ];
      taskDTO = {
        reportName: this.form.reportName,
        appCode: 'ec-pc-new',
        paramMap: fields,
      };

      this.$q.common
        .uploadFile({
          data: {
            file: this.fileList[0],
            taskDTO: JSON.stringify(taskDTO),
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success('数据导入中，请稍后');
          } else {
            this.$message.error(res.message);
          }
          this.fjLoading = false;
          this.cancel();
          this.handleSearch();
        });
    },
    currentMonthStr(num) {
      return num == 12 ? num : `0${num}`
    }
  },
  mounted() {
    this.storeName = sessionStorage.getItem('storeName');
    this.form.reportName = this.$route.query.reportName;
    this.handleSearch();
  },
};
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 65px)
>>> .el-header
  padding 10px
  .el-form-item
    margin-bottom 10px
>>> .el-dialog__body
    padding 20px
.itembox >>> .el-form-item {
  margin-bottom 10px
}
</style>
